import { CardsCardStatus } from '@dock/types-dock-partner';

import { cardStatusOptions } from './cardStatusOptions';

export const getDefaultCardStatus = (cardStatus: CardsCardStatus): CardsCardStatus =>
    cardStatusOptions.find(({ label }) => cardStatus === label)?.value || CardsCardStatus.ACTIVATED;
